import type React from 'react';

import { token } from '@atlaskit/tokens';

import { BannerStateContainer } from '@confluence/banners';

export const whiteboardHeightContainer = [BannerStateContainer];
export const whiteboardShellStyle = (
	topNavAndBannerHeight: number,
	isSSR: boolean,
	isSidePanelOpen: boolean = false,
): React.CSSProperties => ({
	width: isSidePanelOpen ? 'calc(100% - 320px)' : '100%',
	height: `calc(100vh - ${topNavAndBannerHeight}px)`,
	display: 'block',
	opacity: isSSR ? 0 : 1,
	backgroundColor: token('elevation.surface'),
	...(isSidePanelOpen ? { transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s' } : {}),
});
